<script lang="ts" setup>
const {
  title,
  isSearchVisable = true,
  isBackButtonVisible = true,
} = defineProps<{
  title: string;
  isSearchVisable?: boolean;
  isBackButtonVisible?: boolean;
}>();

const { t } = useI18n();
const businessStore = useBusinessStore();
const { search, isSearchOpen } = storeToRefs(businessStore);
const { canGoBack, goBack } = useNavigationHistory();

const { openSearch } = businessStore;
const route = useRoute();

if (!isSearchVisable && isSearchOpen.value) {
  isSearchOpen.value = false;
}

const searchPlaceholder = computed(() => {
  return (route?.meta?.keys as Array<string>)?.includes("products")
    ? t("search.search_products")
    : t("search.search_services");
});

function handleSearch() {
  if ((route?.meta?.keys as Array<string>)?.includes("products")) {
    businessStore.searchProductByName();
  } else {
    businessStore.searchServiceByName();
  }
}
</script>

<template>
  <div
    class="shrink-0 px-3 h-16 flex items-center bg-white border-b border-gray-100"
  >
    <div class="flex-1 flex items-center justify-between">
      <div
        v-if="!isSearchOpen || !isSearchVisable"
        class="flex items-center gap-x-2"
      >
        <template v-if="isBackButtonVisible">
          <UButton
            v-if="canGoBack"
            icon="i-approved-arrow-left"
            size="xl"
            class="rounded-xl"
            color="gray"
            variant="ghost"
            :ui="{ square: { xl: 'p-2' } }"
            @click="goBack"
          />
        </template>
        <div>
          <h6 class="font-semibold capitalize text-gray-900">{{ $t(`${title}`) }}</h6>
          <p class="text-sm text-gray-500">{{ $t(`${title}_desc`) }}</p>
        </div>
      </div>

      <template v-if="isSearchVisable">
        <div v-if="isSearchOpen" class="flex-1 flex items-center">
          <div class="shrink-0">
            <UButton
              icon="i-approved-arrow-left"
              size="xl"
              color="gray"
              variant="ghost"
              class="rounded-xl"
              :ui="{ square: { xl: 'p-2' } }"
              @click="isSearchOpen = false"
            />
          </div>
          <div class="flex-1 relative">
            <input
              v-model="search"
              name="search"
              type="text"
              :placeholder="searchPlaceholder"
              class="w-full bg-transparent text-sm font-medium text-gray-900 placeholder-gray-400 py-2 ps-2 pe-10 focus:outline-none"
              autofocus
              @keyup="handleSearch"
            >
            <button
              v-show="search !== ''"
              type="button"
              class="absolute inset-y-0 end-2 my-auto h-6 w-6 inline-flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
              @click="businessStore.clearSearch"
            >
              <UIcon name="i-approved-close" class="size-4" />
            </button>
          </div>
        </div>
        <UButton
          v-else
          icon="i-approved-search"
          size="xl"
          color="gray"
          variant="ghost"
          class="rounded-xl"
          :ui="{ square: { xl: 'p-2' } }"
          @click="openSearch"
        />
      </template>
    </div>
  </div>
</template>
